// ultraviolet
export var ultraViolets = {
  10: '#F0EFFF',
  20: '#DFDEFF',
  30: '#D0CDFF',
  40: '#B3AEFF',
  50: '#9585FF',
  60: '#775CFF',
  70: '#612FFF',
  80: '#4F00D6',
  90: '#30008F',
  100: '#15005C'
}; // grey

export var greys = {
  10: '#F6F7F8',
  20: '#E8EAED',
  30: '#D7DBE0',
  40: '#B0B6BF',
  50: '#868E98',
  60: '#6C747F',
  70: '#545B63',
  80: '#42474D',
  90: '#2F3237',
  100: '#1A1D21'
}; // green

export var greens = {
  10: '#E0F7E7',
  30: '#B1FBB1',
  50: '#0BEA82',
  70: '#08AF61',
  90: '#067F46'
}; // orange

export var oranges = {
  10: '#FFEDE0',
  30: '#FFD0AD',
  50: '#FF8E3C',
  70: '#D68100',
  90: '#B87400'
}; // red

export var reds = {
  10: '#FFE0E0',
  30: '#FFADAD',
  50: '#FF4F42',
  70: '#B80D00',
  90: '#990000'
}; // teal

export var teals = {
  10: '#EBFFF9',
  30: '#B8FFEA',
  50: '#0AFFD4',
  70: '#00ADAD',
  90: '#007A7A'
}; // yellow

export var yellows = {
  10: '#FFF8E0',
  30: '#FFECAD',
  50: '#FFD014',
  70: '#E0BB00',
  90: '#C2A200'
}; // purples

export var purples = {
  50: '#D200A3' // Adam: only for gradients

}; // pinks

export var pinks = {
  50: '#F80F6b' // Adam: only for gradients

}; // basics

export var white = '#fff';
export var black = '#000'; // legacy
// red

export var red = '#FF4F42';
export var redLight = '#ffcac6';
export var lightRed = redLight; // for backwards compatibility (and all instances of this below)

export var redLightest = '#fff1f0'; // yellow

export var yellow = '#FFC94C';
export var yellowLight = '#ffeec9';
export var lightYellow = yellowLight;
export var yellowLightest = '#FFF9ED'; // ultraviolet

export var ultraViolet = '#612FFF';
export var lightUltraViolet = '#E6DEFF';
export var ultraVioletLight = lightUltraViolet;
export var lightestUltraViolet = '#F9F7FF';
export var ultraVioletLightest = lightestUltraViolet;
export var ultraviolet30 = '#D9CDFF'; // teal

export var teal = '#30808B';
export var tealLight = '#C0E8D7';
export var lightTeal = tealLight;
export var tealLightest = '#DFF4F7'; // green

export var green = '#2FB47C';
export var lightGreen = '#ebfcf9'; // blue

export var blue = '#34BACC';
export var lightBlue = '#C2EAF0'; // 50 shades of grey

export var ink = '#2A2A2A';
export var grey = '#A9A9AE';
export var grey30 = '#D7DBE0';
export var darkGrey = '#54545E';
export var softGrey = '#EBECF0';
export var bgGrey = '#F7F7F9';
export var flatGrey = '#d1d2d5';
export var textDarkGrey = '#212429';
export var borderLightGrey = '#e1e7f0';
export var greyOnGreyText = '#87878E';
export var inputBorder = softGrey;
export var inputBorderFocused = ink;
export var inputBackground = '#FCFCFD'; // orange

export var awOrange = '#ff9800';
export var orange = '#FF8E3C';
export var lightOrange = '#FDF1E0';
export var primary = orange; // gradients

export var orangeGradient1 = ['#ff8439', yellow];
export var orangeGradient2 = ['#ff4244', orange];
export var redGradient = ['#f80f6b', red];
export var pinkGradient = ['#c600ad', '#ff135f'];
export var purpleGradient = [ultraViolet, '#d200a3'];
export var blueGradient = ['#34ccb7', blue];
export var DerpColor = '#fff';
export var gradients = [orangeGradient1, orangeGradient2, redGradient, pinkGradient, purpleGradient, blueGradient];